module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact appoint_form_outer"
  }, [_c('form', {
    staticClass: "form-contact__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell",
    class: {
      'form-contact__label--active': _vm.yourName
    }
  }, [_c('span', [_vm._v("Patient's Name")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("*    ")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yourName),
      expression: "yourName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('yourName')
    },
    attrs: {
      "name": "yourName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.yourName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourName = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('yourName')),
      expression: "errors.has('yourName')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v("Patient name is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell",
    class: {
      'form-contact__label--active': _vm.email
    }
  }, [_c('span', [_vm._v("Patient's Email ")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("*         ")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-contact__input",
    class: {
      'input': true, 'form-contact__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v(" Please Input a Valid Email       ")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell",
    class: {
      'form-contact__label--active': _vm.phoneNumber
    }
  }, [_c('span', [_vm._v("Patient's Phone Number ")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("*        ")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phoneNumber')),
      expression: "errors.has('phoneNumber')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v(" Please input a valid number ")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell",
    class: {
      'form-contact__label--active': _vm.patientBirthday
    }
  }, [_c('span', [_vm._v("Patient's Birthday        ")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientBirthday),
      expression: "patientBirthday"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('patientBirthday')
    },
    attrs: {
      "name": "patientBirthday",
      "type": "date"
    },
    domProps: {
      "value": (_vm.patientBirthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientBirthday = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell",
    class: {
      'form-contact__label--active': _vm.message
    }
  }, [_vm._v("Message ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-contact__textarea",
    class: {
      'form-contact__input--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v("Message is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "form-main__input--small agreefiled form-virtual-consult__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-virtual-consult__input--checkbox",
    class: {
      'form-virtual-consult__checkbox-overlay--error': _vm.errors.has('agree')
    },
    attrs: {
      "name": "agree",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, null) > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _vm._m(0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('agree')),
      expression: "errors.has('agree')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v("Please Check Agree box to Proceed.          ")])])]), _vm._m(1), _c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--inline"
  }, [_c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('label', {
    staticClass: "form-virtual-consult__input--upload"
  }, [_c('input', {
    ref: "uploads",
    staticClass: "multipleupp",
    attrs: {
      "name": "images",
      "type": "file",
      "accept": "image/jpg, image/jpeg, image/png",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.upload
    }
  }), _c('span', [_vm._v("Choose Files")])])]), _c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', [_vm._v(_vm._s(_vm.images) + " images uploaded.      ")])])]), _c('div', {
    staticClass: "form-main__button"
  }, [_c('div', {
    staticClass: "form-contact__submit-button",
    class: {
      'form-contact__submit-button--success': _vm.formSuccess
    },
    on: {
      "click": _vm.validate
    }
  }, [_c('div', {
    staticClass: "form-contact__submit-overlay",
    class: {
      'form-contact__submit-overlay--showing': _vm.formSubmitted && !_vm.formSuccess
    }
  }), _c('span', {
    staticClass: "form-main__submit-button",
    class: {
      'form-contact__submit-label--hidden': _vm.formSuccess
    }
  }, [_vm._v("SEND")]), _c('div', {
    staticClass: "form-contact__submit-success",
    class: {
      'form-contact__submit-success--showing': _vm.formSuccess
    }
  }), _c('span', {
    staticClass: "form-contact__submit-check",
    class: {
      'form-contact__submit-check--showing': _vm.formSuccess
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-virtual-consult__label"
  }, [_c('span', [_vm._v("By checking this box I agree to send my photos and information via email and I understand that the virtual exam is not always an exact diagnosis. In some cases additional records or appointments may be required.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "labell"
  }, [_vm._v("File Attachment ")]), _c('div', {
    staticClass: "labell"
  }, [_vm._v("(You Can Upload Multiple Images by Command + Click (Mac) or Ctrl + Click for Windows)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23dd9ec0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/appointment-request-form/appointment-request-form.pug
// module id = 1272
// module chunks = 1